export default __webpack_public_path__ + "static/media/laundry1-afterA-1440w.257479d1.png";